<style lang="scss" scoped>
  .NewARElement {
    margin-top: 6rem;
    padding-bottom: 0.3rem;

    .active {
      background-image: linear-gradient(74deg, #ff5000, #ed8a16);
    }

    .disabled {
      background-image: linear-gradient(74deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25));
    }

    .column {
      padding-top: 0;
      padding-bottom: 0;
    }

    &__title {
      padding-top: 1rem;
      height: 2rem;
      width: 105.3px;
      color: #FFFFFF;
      font-family: "Open Sans";
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
    }

    &__select-button {
      padding-top: 6px;
      cursor: pointer;
      width: 143px;
      height: 30px;
      border-radius: 14.6px;
      display: inline-block;

      font-size: 10.2px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.3px;
      text-align: center;
      color: #ffffff;
      background: linear-gradient(45deg, #FF5000 0%, #ED8A16 100%);

      // height: 30px;
      // width: 143px;
      // border-radius: 14.58px;
      // background: linear-gradient(45deg, #FF5000 0%, #ED8A16 100%);
      // text-align: center;
      // color: #ffffff;
    }

    &__filename {
      margin-left: 2rem;
    }

    &__close {
      float: right;
      margin-right: 1rem;
      margin-top: 0.5rem;
    }
    &__separator {
      width: 100%;
      border: solid 1px #f0f0f0;
    }

    &__select-input {
      display: none;
    }
    &__removeRightPadding {
      margin-right: 0px;
    }
    &__textInput {
      outline: none;
      border: none;
      border-color: transparent;
      font-size: 2rem;
      height: 1.33rem;
      width: 100%;
      font-size: 14px;
    
      @media only screen and (max-width: 770px) {
        margin-left: 40px;
    }
    }
    &__textInput:focus {
      outline: none;
      border: none;
      border-color: transparent;
    }
  }
</style>

<template lang="pug">
  .NewARElement
    .columns.box.NewARElement__removeRightPadding
      .column.is-3.is-paddingless
      .column.is-paddingless
        input(type='text' v-model.trim="newARElementName" placeholder='New AR element' @keyup.enter="onPressEnter" @keyup.escape="onPressingEscape").NewARElement__textInput
        //-   .NewARElement__select-button
        //-     span.NewARElement__title {{title}}
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'NewARElement',

    props: {
      title: String,
      buttonActiveTitle: String,
      buttonDisabledTitle: String,
    },

    data() {
      return {
        newARElementName: '',
      };
    },

    methods: {
      ...mapActions('Firebase', ['createNewARElement']),
      onPressEnter() {
        const elementNameLength = this.newARElementName.length;
        if (elementNameLength >= 1 && elementNameLength <= 20) {
          // Dispatch an action to create a new AR Element.
          this.createNewARElement({ elementName: this.newARElementName,
            roomID: this.$route.params.id });
          // Reset the ar element name.
          this.newARElementName = '';
        } else {
          // eslint-disable-next-line no-console
          console.log('Invalid input.');
        }
      },

      onClick() {
        // Emit the remove event and
        // the onRemove callback will get fired in the component
        // configuration in ARElement.vue
        this.$emit('remove');
        this.file = null;
      },

      onPressingEscape() {
        this.newARElementName = '';
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/Room/components/NewARElement.vue